import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CompareRoutingModule } from './compare-routing.module';
import { PopularComparisonComponent } from './popular-comparison.component';
import { CompareProductComponent } from '../compare-product/compare-product.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

@NgModule({
  declarations: [PopularComparisonComponent,CompareProductComponent],
  imports: [
    CommonModule,
    CompareRoutingModule,FormsModule, ReactiveFormsModule
  ],
  exports: [
    CompareProductComponent
  ]
})
export class CompareModule { }
